import { SvgIcon, SvgIconProps } from '@mui/material';

const IconGallery = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 28 28" {...props}>
    <defs>
      <clipPath id="clip-icon_filetype_photo">
        <rect width="42" height="42" />
      </clipPath>
    </defs>
    <g id="icon_filetype_photo" clipPath="url(#clip-icon_filetype_photo)">
    <g id="icon_gallery" transform="translate(-1002 -127)">
    <rect id="Dimensions" width="42" height="42" transform="translate(1002 127)" fill="none"/>
    <path id="image" d="M24.917,4.083V24.917H21.211L11.1,13.8a1.042,1.042,0,0,0-1.449-.09L4.083,18.485V4.083ZM4.083,24.917V21.229l6.16-5.28L18.4,24.917ZM4.083,2A2.083,2.083,0,0,0,2,4.083V24.917A2.083,2.083,0,0,0,4.083,27H24.917A2.083,2.083,0,0,0,27,24.917V4.083A2.083,2.083,0,0,0,24.917,2ZM20.75,10.333a2.083,2.083,0,1,0-2.083,2.083A2.083,2.083,0,0,0,20.75,10.333Zm2.083,0a4.167,4.167,0,1,1-4.167-4.167A4.167,4.167,0,0,1,22.833,10.333Z" transform="translate(1001.5 127)" fill="#141414" />
  </g>
    </g>
  </SvgIcon>
);

export default IconGallery;